<template>
  <div
    class="remittance-service-container"
    :class="{ 'is-visible': isVisible }"
  >
    <!-- 左侧背景 -->
    <div class="left-bg">
      <img src="@/assets/imgsnew/page1left.svg" alt="Left background" />
      <div class="stats-container">
        <div class="stat-item">
          <div class="number">
            <span class="prefix">+</span>
            <span class="animate-number">{{ displayNumbers.num1 }}</span>
          </div>
          <div class="description">
            <div>Branches</div>
            <div>across the UAE</div>
          </div>
        </div>
        <div class="stat-item">
          <div class="number">
            <span class="prefix">+</span>
            <span class="animate-number">{{ displayNumbers.num2 }}</span>
            <span class="suffix">M</span>
          </div>
          <div class="description">
            <div>Unique</div>
            <div>Customers</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 中间转账界面 -->
    <div class="transfer-container">
      <div class="transfer-card">
        <div class="currency-selector">
          <div class="send">
            <span>Send</span>
            <div class="currency">
              <div><img src="@/assets/imgsnew/page1-1.svg" alt="AED" /></div>
              <div>AED</div>
            </div>
          </div>
          <div class="receive">
            <span>Receive</span>
            <div class="currency">
              <div><img src="@/assets/imgsnew/page1-2.svg" alt="USD" /></div>
              <div>USD</div>
            </div>
          </div>
        </div>
        <div class="amount-input">
          <input type="text" value="100" class="send-amount" />
          <input
            type="text"
            value="27.1700000"
            class="receive-amount"
            readonly
          />
        </div>
        <div class="exchange-rate">
          1AED=0.27170000 USD Indicative exchange rate
        </div>
        <div class="transfer-method">Transfer Method | Bank Transfer</div>
        <button class="send-money-btn">Send Money</button>
        <!-- <div class="app-stores">
          <div class="store-button">
            <img src="@/assets/imgsnew/page1-3.svg" alt="Apple" />
            <div class="button-text">
              <span class="small-text">Download on the</span>
              <span class="large-text">App Store</span>
            </div>
          </div>
          <div class="store-button">
            <img src="@/assets/imgsnew/page1-4.svg" alt="Android" />
            <div class="button-text">
              <span class="large-text">Android Download</span>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- 右侧背景 -->
    <div class="right-bg">
      <img src="@/assets/imgsnew/page1right.svg" alt="Right background" />
      <div class="stats-container">
        <div class="stat-item">
          <div class="number">
            <span class="prefix">+</span>
            <span class="animate-number">{{ displayNumbers.num3 }}</span>
          </div>
          <div class="description">
            <div>Banks and agent</div>
            <div>locations worldwide</div>
          </div>
        </div>
        <div class="stat-item">
          <div class="number">
            <span class="prefix">+</span>
            <span class="animate-number">{{ displayNumbers.num4 }}</span>
          </div>
          <div class="description">
            <div>Years</div>
            <div>of trust</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RemittanceServicePage",
  data() {
    return {
      displayNumbers: {
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
      },
      finalNumbers: {
        num1: 260,
        num2: 3,
        num3: 500,
        num4: 50,
      },
      isVisible: false,
      animationTriggered: false,
    };
  },
  methods: {
    startAnimation() {
      if (!this.animationTriggered) {
        this.animationTriggered = true;
        Object.keys(this.finalNumbers).forEach((key) => {
          this.animateNumber(key);
        });
      }
    },
    resetNumbers() {
      Object.keys(this.displayNumbers).forEach((key) => {
        this.displayNumbers[key] = 0;
      });
    },
    animateNumber(key) {
      const finalValue = this.finalNumbers[key];
      const frames = 30;
      let frame = 0;

      const animate = () => {
        frame++;
        const progress = frame / frames;
        this.displayNumbers[key] = Math.round(finalValue * progress);

        if (frame < frames) {
          requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
    },
  },
  mounted() {
    const options = {
      threshold: 0.3,
      rootMargin: "50px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.isVisible = entry.isIntersecting;
        if (entry.isIntersecting && !this.animationTriggered) {
          this.startAnimation();
        } else if (!entry.isIntersecting) {
          this.resetNumbers();
          this.animationTriggered = false;
        }
      });
    }, options);

    observer.observe(this.$el);
    this.observer = observer;
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>

<style scoped>
.remittance-service-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  background: #f5f7fa;
  max-width: 100%;
  margin: 0 auto;
  gap: 2rem;
  position: relative;
  width: 100%;
  overflow: hidden;
}

.left-bg,
.right-bg {
  position: relative;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0;
  width: 400px;
}

.left-bg img,
.right-bg img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

.left-bg img {
  margin-right: -20px;
}

.right-bg img {
  margin-left: -20px;
}

.left-bg .stats-container {
  left: 60%;
  transform: translate(-50%, -50%);
}

.right-bg .stats-container {
  left: 40%;
  transform: translate(-50%, -50%);
}

.transfer-container {
  flex: 0 0 auto;
  padding: 0;
  margin: 2rem 0;
  z-index: 1;
}

.transfer-card {
  background: #1e3255;
  color: white;
  padding: 2rem;
  border-radius: 50%;
  width: 320px;
  height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.currency-selector {
  display: flex;
  justify-content: center;
  gap: 3rem;
  margin-bottom: 1.2rem;
  width: 100%;
}

.currency-selector .send,
.currency-selector .receive {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.currency-selector span {
  font-size: 0.7rem;
  color: #ffffff99;
  margin-bottom: 0.2rem;
}

.currency-selector .currency {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.9rem;
  font-weight: bold;
}

.currency-selector .currency img {
  width: 20px;
  height: 20px;
}

.amount-input {
  width: 90%;
  margin-bottom: 1rem;
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.8);
  border-radius: 50px;
  padding: 3px;
  position: relative;
  display: flex;
  align-items: center;
  height: 42px;
}

.amount-input input {
  padding: 0.5rem 1rem;
  height: 36px;
  line-height: 36px;
  border: none;
  background: transparent;
  color: white;
  font-size: 1rem;
  text-align: center;
  width: 50%;
  outline: none;
}

.amount-input::after {
  content: "|";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.5rem;
  font-weight: 200;
}

.amount-input input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.amount-input input:disabled,
.amount-input input[readonly] {
  color: white;
  opacity: 1;
}

.exchange-rate {
  font-size: 0.65rem;
  color: #ffffff99;
  text-align: center;
  margin-bottom: 1rem;
}

.transfer-method {
  font-size: 0.7rem;
  color: #ffffff99;
  text-align: center;
  margin-bottom: 1.2rem;
}

.send-money-btn {
  width: 80%;
  padding: 0.6rem;
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  color: #ffffff;
  font-weight: 600;
  font-size: 0.8rem;
  cursor: pointer;
  margin-bottom: 1.2rem;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}

.send-money-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: #ffffff;
}

.app-stores {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 1.2rem;
}

.store-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  padding: 6px 12px;
  border-radius: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100px;
  height: 36px;
}

.store-button img {
  height: 20px;
  width: 20px;
}

.button-text {
  display: flex;
  flex-direction: column;
  color: #000000;
  font-family: MiSans;
}

.button-text .small-text {
  font-size: 7px;
  font-weight: 500;
  line-height: 9px;
  text-align: left;
}

.button-text .large-text {
  font-size: 9px;
  font-weight: 600;
  line-height: 11px;
  text-align: left;
}

.store-button:hover {
  opacity: 0.9;
}

.stats-container {
  position: absolute;
  top: 50%;
  padding: 0;
  width: max-content;
  z-index: 2;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
  opacity: 0;
  transform: translateY(80px);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.number {
  display: flex;
  align-items: center;
  font-family: MiSans-Bold;
  font-size: 30px;
  font-weight: 900;
  line-height: 60px;
  background: linear-gradient(180deg, #30568f 0%, #193371 126.67%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.number .prefix,
.number .suffix {
  font-family: MiSans-Bold;
  background: linear-gradient(180deg, #30568f 0%, #193371 126.67%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.animate-number {
  display: inline-block;
  min-width: 2ch;
  text-align: center;
  transition: all 0.05s ease-out;
}

.description {
  color: #0b1f60;
  font-size: 1.2rem;
  line-height: 1.4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: MiSans;
  font-size: 20px;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.description div {
  white-space: nowrap;
}

/* 可选：添加下拉箭头的样式 */
.receive .currency::after {
  content: "▼";
  font-size: 0.8rem;
  margin-left: 4px;
  color: rgba(255, 255, 255, 0.6);
}

/* 添加动画相关的样式 */
.stat-item .number {
  opacity: 1;
}

.stat-item .description {
  opacity: 1;
}

/* 为左侧两个统计项添加延迟 */
.left-bg .stat-item:nth-child(1) .number {
  animation-delay: 0s;
}

.left-bg .stat-item:nth-child(1) .description {
  animation-delay: 0.1s;
}

.left-bg .stat-item:nth-child(2) .number {
  animation-delay: 0.2s;
}

.left-bg .stat-item:nth-child(2) .description {
  animation-delay: 0.3s;
}

/* 为右侧两个统计项添加延迟 */
.right-bg .stat-item:nth-child(1) .number {
  animation-delay: 0.4s;
}

.right-bg .stat-item:nth-child(1) .description {
  animation-delay: 0.5s;
}

.right-bg .stat-item:nth-child(2) .number {
  animation-delay: 0.6s;
}

.right-bg .stat-item:nth-child(2) .description {
  animation-delay: 0.7s;
}

/* 当元素出现在视口时触发动画 */
.stat-item.in-view .number,
.stat-item.in-view .description {
  animation: none;
}

@keyframes slideUpFade {
  0% {
    opacity: 0;
    transform: translateY(80px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 添加动画重置类 */
.stat-item.reset-animation .number {
  animation: none;
}

.stat-item.reset-animation .description {
  animation: none;
}

/* 为左侧统计项添加动画延迟 */
.left-bg .stat-item:nth-child(1) {
  transition-delay: 0.1s;
}

.left-bg .stat-item:nth-child(2) {
  transition-delay: 0.2s;
}

/* 为右侧统计项添加动画延迟 */
.right-bg .stat-item:nth-child(1) {
  transition-delay: 0.3s;
}

.right-bg .stat-item:nth-child(2) {
  transition-delay: 0.4s;
}

/* 当组件可见时显示统计项 */
.remittance-service-container.is-visible .stat-item {
  opacity: 1;
  transform: translateY(0);
}

/* 平板电脑和小屏幕设备 (小于1024px) */
@media screen and (max-width: 1024px) {
  .remittance-service-container {
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.5rem 1rem;
    align-items: center;
  }

  .left-bg,
  .right-bg {
    width: 100%;
    max-width: 500px;
    position: relative;
    height: 180px;
    display: flex;
    justify-content: center;
  }

  .stats-container {
    position: absolute;
    top: 50%;
    left: 55%;
    transform: translate(-50%, -50%);
    width: 90%;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .left-bg .stats-container {
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .left-bg .stat-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    text-align: center;
    justify-content: center;
  }

  .left-bg .number {
    text-align: center;
  }

  .left-bg .description {
    text-align: center;
  }

  .left-bg .description div {
    text-align: center;
  }

  .right-bg .stats-container {
    left: 52%;
  }

  .right-bg .stat-item {
    text-align: left;
    justify-content: flex-start;
  }

  .right-bg .description {
    text-align: left;
  }

  .right-bg .description div {
    text-align: left;
  }

  .left-bg img,
  .right-bg img {
    width: 90%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  .stat-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    text-align: left;
  }

  .number {
    font-size: 36px;
    line-height: 1.2;
    white-space: nowrap;
    display: flex;
    align-items: center;
  }

  .description {
    font-size: 18px;
    line-height: 1.3;
    text-align: left;
  }

  .description div {
    white-space: nowrap;
  }

  .transfer-card {
    width: 320px;
    height: 320px;
    gap: 0.2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
  }

  .currency-selector {
    gap: 2rem;
    margin-bottom: 0.2rem;
  }

  .amount-input {
    margin-bottom: 0.2rem;
    height: 42px;
  }

  .amount-input input {
    padding: 0.4rem 0.6rem;
    height: 35px;
    font-size: 0.9rem;
  }

  .amount-input::after {
    font-size: 1.2rem;
    height: 20px;
    line-height: 20px;
  }

  .exchange-rate {
    margin: 0;
    padding: 0;
    font-size: 0.65rem;
    line-height: 1;
    height: 14px;
  }

  .transfer-method {
    margin: 0;
    padding: 0;
    font-size: 0.7rem;
    line-height: 1;
    height: 14px;
  }

  .send-money-btn {
    margin-bottom: 1.5rem;
    padding: 0.4rem;
    height: 32px;
  }

  .app-stores {
    position: absolute;
    bottom: 12%;
    left: 50%;
    transform: translateX(-50%);
    margin: 0;
    gap: 8px;
    width: 85%;
  }

  .store-button {
    width: 100px;
    height: 36px;
    padding: 6px 10px;
    border-radius: 20px;
  }

  .store-button img {
    height: 20px;
    width: 20px;
  }

  .button-text .small-text {
    font-size: 6px;
    line-height: 9px;
  }

  .button-text .large-text {
    font-size: 6px;
    line-height: 11px;
  }
}

/* 移动设备 (小于768px) */
@media screen and (max-width: 768px) {
  .remittance-service-container {
    gap: 1.2rem;
  }

  .left-bg,
  .right-bg {
    height: 160px;
  }

  .transfer-card {
    width: 320px;
    height: 320px;
    gap: 0.15rem;
  }

  .number {
    font-size: 32px;
  }

  .description {
    font-size: 16px;
  }

  .stats-container {
    gap: 1.2rem;
  }

  .left-bg .stats-container {
    left: 50%;
  }

  .right-bg .stats-container {
    left: 54%;
  }

  .store-button {
    width: 100px;
    height: 36px;
    padding: 6px 12px;
    border-radius: 18px;
  }

  .store-button img {
    height: 20px;
    width: 20px;
  }

  .button-text .small-text {
    font-size: 7px;
  }

  .button-text .large-text {
    font-size: 9px;
  }

  .amount-input {
    height: 40px;
  }

  .amount-input input {
    padding: 0.3rem 0.5rem;
    height: 32px;
    font-size: 0.8rem;
  }

  .amount-input::after {
    font-size: 1.1rem;
    height: 18px;
    line-height: 18px;
  }

  .exchange-rate {
    font-size: 0.6rem;
    height: 14px;
  }

  .transfer-method {
    font-size: 0.65rem;
    height: 14px;
  }

  .app-stores {
    bottom: 10%;
  }

  .send-money-btn {
    margin-bottom: 1.8rem;
  }
}

/* 小型移动设备 (小于480px) */
@media screen and (max-width: 480px) {
  .remittance-service-container {
    gap: 1rem;
  }

  .left-bg,
  .right-bg {
    height: 140px;
  }

  .transfer-card {
    width: 320px;
    height: 320px;
    gap: 0.1rem;
  }

  .number {
    font-size: 28px;
  }

  .description {
    font-size: 15px;
  }

  .stats-container {
    gap: 1rem;
  }

  .stat-item {
    gap: 0.8rem;
  }

  .left-bg .stats-container {
    left: 50%;
  }

  .right-bg .stats-container {
    left: 56%;
  }

  .transfer-card {
    gap: 0.6rem;
  }

  .currency-selector,
  .amount-input,
  .exchange-rate,
  .transfer-method,
  .send-money-btn {
    margin-bottom: 0.2rem;
  }

  .store-button {
    width: 95px;
    height: 34px;
    padding: 6px 12px;
    border-radius: 18px;
  }

  .store-button img {
    height: 20px;
    width: 20px;
  }

  .button-text .small-text {
    font-size: 7px;
  }

  .button-text .large-text {
    font-size: 9px;
  }

  .exchange-rate {
    font-size: 0.55rem;
    height: 12px;
  }

  .transfer-method {
    font-size: 0.6rem;
    height: 12px;
  }

  .amount-input {
    height: 36px;
  }

  .amount-input input {
    padding: 0.25rem 0.4rem;
    height: 28px;
    font-size: 0.75rem;
  }

  .amount-input::after {
    font-size: 1rem;
    height: 16px;
    line-height: 16px;
  }

  .app-stores {
    bottom: 8%;
  }

  .send-money-btn {
    margin-bottom: 1.5rem;
  }
}

/* 横屏支持 */
@media screen and (max-width: 1024px) and (orientation: landscape) {
  .remittance-service-container {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 1rem;
  }

  .left-bg,
  .right-bg {
    flex: 1 1 40%;
    min-width: 300px;
  }

  .transfer-container {
    flex: 0 1 auto;
  }
}

/* 如果有背景图片相关的样式，确保它们在容器内 */
.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}
</style>
